import { render } from "./bipolarChart.vue?vue&type=template&id=4d1a3d4e"
import script from "./bipolarChart.vue?vue&type=script&lang=js"
export * from "./bipolarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__